import { PhoneViewModel } from '../../models/Entities/Person/Phone/PhoneModels';
import { CommonState } from '../common/state/commonState';

export interface PersonPhoneState extends CommonState<PhoneViewModel> {
    lastCreated?: PhoneViewModel;
}

export const PersonPhoneUnloadState: PersonPhoneState = {
    isLoadingAll: false,
    successLoadingAll: undefined,
    failOnLoadingAll: false,

    isLoadingOne: false,
    successLoadingOne: undefined,
    failOnLoadingOne: false,

    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,

    isDeletingOne: false,
    successDeletingOne: undefined,
    failOnDeletingOne: false,

    list: [],
    error: undefined,
    lastCreated: undefined
};
